<template>
	<div class="half_layer_wrap popup">
		<div class="bg_overlay"></div>
		<div class="half_layer_wrap_inner" style="padding: 20px 0 0" :class="is_ready ? 'slide-up' : 'slide-down'">
			<article class="half_view">
				<div class="layer_title justify-space-between items-center">
					<h3><slot name="title"></slot></h3>
					<button
						@click="cancel"
						class=""
					>
						<i class="icon icon-close"></i>
					</button>
				</div>
				<div class="hlayer" style="margin: 0 20px">
					<div class="create_wallet ptb-20">
						<ul class="mt-10">
							<slot name="list"></slot>
						</ul>
					</div>
				</div>
			</article>
			<div
				v-if="is_confirm"
				class="btn_area mt-10"
			>
				<button
					class="btn_l btn_fill_blue"
					style="border-radius: unset;"
					@click="$emit('click')"
					:disabled="is_disabled"
				>확인</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'popup_select'
	, props: ['is_disabled', 'is_confirm']
	, data: function(){
		return {
			is_ready: false
		}
	}
	, methods: {
		cancel: function(){
			this.is_ready = false
			setTimeout( () => {
				this.$emit('cancel')
			}, 500)

		}
	}
	, created() {
		setTimeout( () => {
			this.is_ready = true
		}, 0)
	}
}
</script>